export default "__VITE_ASSET__Wa9QZIaW__"